<template functional>
  <div id="empty-cell-square">
    <img src="../assets/empty-cell-short.svg" draggable="false" style="width:100%;height:100%;max-width:10px;max-height:10px;min-width:10px;min-height:10px;" />
  </div>
</template>

<script>

export default {
  name: "EmptyCellSquare"
};
</script>

<style scoped>
img {
  display: block;
}
</style>